// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "lingy/css/" + chunkId + "." + {"272":"b2ce2ef4","385":"9bf54599","536":"92f6132e","549":"8ae7c9ba","588":"a2357619","898":"2771ace9","910":"dfb220e8"}[chunkId] + ".css";
};